import { HashLink } from 'react-router-hash-link';

function SidebarListItem({
    name,
    current
}) {
    return (
        <li
            className={`sidebar__list__item ${name === current.name ? "current" : ""}`}
            onClick={() => current.setCurrent(name)}
            role="link"
        >
            <HashLink smooth to={`#${name}`} className="sidebar__list__link">
                <span>{name.charAt(0)}</span>
                <span className="--deactivate">{name.slice(1)}</span>
            </HashLink>
        </li>
    )
}
export default SidebarListItem